import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoPresetInput.scss';

import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoPresetEnum } from '../../../types/enums/VideoPresetEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoPresetInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoPresetEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${VideoPresetEnum[key as keyof typeof VideoPresetEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoPreset: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoPreset: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-preset-input">
      <div className="input-title">
        {t('producer.inputs.video-preset.title')}
        <Help
          title="Video Preset"
          text="<b>Ultrafast:</b> Provides the fastest encoding speed with lower compression efficiency. Useful for streams where minimal latency is critical.<br/><br/><b>Superfast:</b> Balances speed and compression efficiency. Slightly slower than Ultrafast but with better video quality.<br/><br/><b>Veryfast:</b> Prioritizes compression efficiency and video quality over speed. Best for higher-quality streams when a small increase in latency is acceptable."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoPreset.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-preset.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-preset.footer')}</div>
    </div>
  );
};

export default React.memo(VideoPresetInput);
